import React, { useEffect, useState } from "react";
import { useTemplateQueries } from "routes/dashboard/DashboardPageRoot";
import { useDashboard } from "routes/dashboard/Dashboard";
import { DashboardDocument } from "components/resources/dashboards/DashboardDocument";
import ResponsiveDialog from "components/dialogs/ResponsiveDialog";
import { TemplateQueryProps, TemplateSearchContent } from "./TemplateSearchContent";
import { findFirstNodeWithField } from "system/query/QueryUtility";
import { QueryLeafNode } from "system/query/QueryLeafNode";
import { currentUser } from "system/InfegyUser";

export interface TemplateSearchDialogProps {
  onClose: () => void;
  onSubmit: (queryIds: string[]) => void;
}

export function TemplateSearchDialog(props: TemplateSearchDialogProps): JSX.Element {
  const dashboard:DashboardDocument = useDashboard();
  const user = currentUser();

  const templateQueriesContext = useTemplateQueries();
  const globalQuery = templateQueriesContext.globalQuery;

  const [globalStartDate, setGlobalStartDate] = useState<string | undefined>(undefined);
  const [globalEndDate, setGlobalEndDate] = useState<string | undefined>(undefined);

  const [templateQueries, setTemplateQueries] = useState<TemplateQueryProps[]>([]);

  useEffect(() => {
    const queries = templateQueriesContext.allTemplateQueries.map(q => q.query);
    const newTemplateQueryProps = queries.map((query: any) => {
      const newTemplateQuery = new TemplateQueryProps(user);
      newTemplateQuery.savedQueryId = query.id;
      newTemplateQuery.queryTitle = query.name;
      newTemplateQuery.usingAIQueryBuilder = false;
      return newTemplateQuery;
    });

    if (!newTemplateQueryProps.length) {
      newTemplateQueryProps.push(new TemplateQueryProps(user));
    }

    setTemplateQueries(newTemplateQueryProps);
  }, [templateQueriesContext.allTemplateQueries]);

  // Find the global query start and end dates
  useEffect(() => {
    if (globalQuery?.query) {
      const dateSegment : QueryLeafNode | undefined = findFirstNodeWithField(globalQuery.query, "published") as (QueryLeafNode | undefined);
      if (dateSegment && dateSegment.value) {
        setGlobalStartDate(dateSegment.value as string);
      } else if (dateSegment && dateSegment.upper && dateSegment.lower) {
        setGlobalStartDate(dateSegment.lower as string);
        setGlobalEndDate(dateSegment.upper as string);
      }
    }
  }, [globalQuery]);

  const [fieldIds, setFieldIds] = useState<string[]>([]);
  const [useDefaults, setUseDefaults] = useState<boolean>(true);

  return (
    <ResponsiveDialog
      open={true}
      onClose={props.onClose}
    >
     {templateQueries.length > 0 &&
        <TemplateSearchContent
          showDashboardSelector={false}
          showCloseButton={true}
          dashboard={dashboard}
          setDashboard={() => { } }
          templateQueries={templateQueries}
          setTemplateQueries={setTemplateQueries}
          fieldIds={fieldIds}
          setFieldIds={setFieldIds}
          useDefaults={useDefaults}
          setUseDefaults={setUseDefaults}
          globalStartDate={globalStartDate}
          setGlobalStartDate={setGlobalStartDate}
          globalEndDate={globalEndDate}
          setGlobalEndDate={setGlobalEndDate}
          onClose={props.onClose}
          />
      }
     </ResponsiveDialog>
  );
}
